

import React, { useState, useEffect } from "react";
import { Modal, Table, Button, Input, Select } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import BiofuelCompositionModal from "./BiofuelCompositionModal";

const { Option } = Select;

export default function BioFuelCompositionListModal({ visible, onClose }) {
  const [compositionVisible, setCompositionVisible] = useState(false);

 
  const [compositionData, setCompositionData] = useState([]);

  
  const [blendInfoData, setBlendInfoData] = useState([]);

  
  useEffect(() => {
    if (visible) {
      const storedComposition = sessionStorage.getItem(
        "biofuelCompositionData"
      );
      const storedBlendInfo = sessionStorage.getItem("biofuelBlendInfoData");

      setCompositionData(
        storedComposition ? JSON.parse(storedComposition) : []
      );
      setBlendInfoData(storedBlendInfo ? JSON.parse(storedBlendInfo) : []);
    }
  }, [visible]);

  const columns = [
    {
      title: "Fuel name",
      dataIndex: "blend_name",
      width: 200,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "Fuel Class",
      dataIndex: "type",
      width: 150,
      render: (text) => (
        <Select value={text} disabled style={{ width: "100%" }}>
          <Option value="biofuel">Biofuel</Option>
          <Option value="fossil">Fossil</Option>
        </Select>
      ),
    },
    {
      title: "Percentage",
      dataIndex: "blend_ratio",
      width: 120,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "LCV(MJ/MT)*",
      dataIndex: "lcv",
      width: 150,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "Cslip*",
      dataIndex: "cslip",
      width: 150,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "EF-TTW (MJfuel)*",
      dataIndex: "ef_ttw_MJfuel",
      width: 180,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "EF-TTW (Gfuel)*",
      dataIndex: "ef_ttw_gfuel",
      width: 180,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "EF-WTT (MJfuel)*",
      dataIndex: "ef_wtt_MJfuel",
      width: 180,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "EF-WTT (Gfuel)*",
      dataIndex: "ef_wtt_gfuel",
      width: 180,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "RWDi*",
      dataIndex: "rwdi",
      width: 120,
      render: (text) => <Input value={text} disabled />,
    },
  ];

  const columnsBio = [
    {
      title: "Blend Ratio (%)",
      dataIndex: "blend_ratio",
      width: 200,
      render: (text) => <Input value={text} disabled />,
    },
    {
      title: "EF-TTW (Gfuel)*",
      dataIndex: "fuel_ef_ttw_gfuel",
      width: 200,
      render: (text) => <Input value={text} disabled />,
    },
  ];

  const handleClose = () => {
   
    onClose();
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={handleClose}
        width={1100}
        style={{ top: 40 }}
        footer={[
          <Button
            key="close"
            icon={<ArrowLeftOutlined />}
            onClick={handleClose}
            style={{
              background: "#E8E8E8",
              border: "none",
            }}
          >
            Close
          </Button>,
          <Button
            key="submit"
            type="primary"
            style={{
              background: "#6E8EFF",
              border: "none",
              padding: "0 22px",
              height: 36,
            }}
          >
            Submit
          </Button>,
        ]}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: 15,
            }}
          >
            <span style={{ fontSize: 20, fontWeight: 600 }}>Composition</span>

            <Button
              type="primary"
              style={{
                background: "#6E8EFF",
                borderRadius: 6,
                padding: "4px 14px",
                fontWeight: 500,
              }}
              onClick={() => setCompositionVisible(true)}
            >
              + Add Biofuel Composition
            </Button>
          </div>
        }
      >
        {/* MAIN TABLE */}
        <Table
          className="fuel-data-stepper-table"
          dataSource={compositionData}
          columns={columns}
          rowKey="id"
          pagination={false}
          scroll={{ x: 1500 }}
          bordered
        />

        <h3 style={{ marginTop: 25, marginBottom: 10 }}>Blend Info</h3>

        {/* BLEND INFO TABLE */}
        <Table
          className="fuel-data-stepper-table fuel-data-stepper-table-bio"
          dataSource={
            blendInfoData.length > 0
              ? blendInfoData
              : [{ id: 1, fuel_ef_ttw_gfuel: "" }]
          }
          columns={columnsBio}
          rowKey="id"
          pagination={false}
          scroll={{ x: 500 }}
          bordered
        />
      </Modal>

      {/* INNER FORM MODAL */}
      <BiofuelCompositionModal
        visible={compositionVisible}
        onClose={() => setCompositionVisible(false)}
        onSubmit={(apiResult) => {
          const apiData = apiResult?.data?.data || [];
          const apiBlend = apiResult?.data?.blend || [];
          const formData = apiResult?.formData || {};

          // Map API data to composition table
          const mappedComposition = apiData.map((item, index) => ({
            id: compositionData.length + index + 1,
            blend_name: item.fuel_name || formData.biofuelName,
            type: item.fuel_type || formData.fuelType,
            blend_ratio: item.blend_percentage || formData.blendRatio,
            lcv: item.lcv,
            ef_ttw_gfuel: item.ef_ttw_gfuel,
            ef_ttw_MJfuel: item.ef_ttw_MJfuel,
            ef_wtt_gfuel: item.ef_wtt_gfuel,
            ef_wtt_MJfuel: item.ef_wtt_MJfuel,
            cslip: item.cslip,
            rwdi: item.rwdi,
          }));

          const updatedComposition = [...compositionData, ...mappedComposition];
          setCompositionData(updatedComposition);

          // Blend info
          const mappedBlend = apiBlend.map((item, index) => ({
            id: blendInfoData.length + index + 1,
            blend_ratio: formData.blendRatio,
            fuel_ef_ttw_gfuel: item.ef_ttw_gfuel,
          }));

          const updatedBlendInfo = [...blendInfoData, ...mappedBlend];
          setBlendInfoData(updatedBlendInfo);

          
          sessionStorage.setItem(
            "biofuelCompositionData",
            JSON.stringify(updatedComposition)
          );
          sessionStorage.setItem(
            "biofuelBlendInfoData",
            JSON.stringify(updatedBlendInfo)
          );

          setCompositionVisible(false);
        }}
      />
    </>
  );
}